import type { ReactNode } from 'react'
import { HelpCircle } from 'lucide-react'

import { cn } from '@/shared/ui/cn'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/shared/ui/primitives/tooltip'

export type HelpTooltipProps = {
  content: ReactNode
  side?: 'top' | 'right' | 'bottom' | 'left'
  label?: string
  className?: string
}

export function HelpTooltip({
  content,
  side = 'top',
  label = 'More information',
  className,
}: HelpTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={label}
            data-slot="help-tooltip"
            className={cn(
              'inline-flex cursor-help items-center justify-center rounded-full outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
              className,
            )}
          >
            <HelpCircle aria-hidden className="size-3.5 text-muted-foreground" />
          </button>
        </TooltipTrigger>
        <TooltipContent side={side}>{content}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
